import { FC, useState } from "react";
import { HtmlContentDisplay } from "./HtmlContentDisplay";
import { RichTextEditor } from "./RichTextEditor";

export type RichTextDisplayProps = {
	content?: string | null;
	truncate?: boolean;
	onContentDoubleClick?: () => void;
};

export type QuickEditRichTextDisplayProps = Omit<RichTextDisplayProps, "onContentDoubleClick"> & {
	ref?: React.Ref<HTMLDivElement>;
	placeholder?: string;
	collapsedPlaceholder?: string;
	onBlur?: () => void;
	onConfirm?: (newContent: string) => void;
};

export const RichTextDisplay: FC<RichTextDisplayProps> = ({
	content,
	onContentDoubleClick,
	truncate,
}) => {
	return (
		content &&
		content !== "<p></p>" && (
			<div
				className="w-full text-left"
				data-testid="rich-text-display"
				onDoubleClick={onContentDoubleClick}
			>
				<HtmlContentDisplay content={content} truncate={truncate} />
			</div>
		)
	);
};

export const QuickEditRichTextDisplay: FC<QuickEditRichTextDisplayProps> = ({
	content,
	truncate,
	ref,
	placeholder,
	collapsedPlaceholder,
	onBlur,
	onConfirm,
}) => {
	const [showEditor, setShowEditor] = useState(false);

	return showEditor ? (
		<div className="w-full text-left">
			<RichTextEditor
				content={content}
				ref={ref}
				placeholder={placeholder}
				collapsedPlaceholder={collapsedPlaceholder}
				onBlur={onBlur}
				onConfirmClick={(newContent: string) => {
					onConfirm && onConfirm(newContent);
					setShowEditor(false);
				}}
				onCancelClick={() => setShowEditor(false)}
			/>
		</div>
	) : (
		<RichTextDisplay
			content={content}
			onContentDoubleClick={() => setShowEditor(true)}
			truncate={truncate}
		/>
	);
};
